import { gql } from '@apollo/client'

const mutation = gql`
  mutation customerAccessTokenCreateWithMultipass($multipassToken: String!) {
    customerAccessTokenCreateWithMultipass(multipassToken: $multipassToken) {
      customerAccessToken {
        accessToken
        expiresAt
      }
      customerUserErrors {
        code
        field
        message
      }
    }
  }
`

/**
 * https://help.shopify.com/en/api/storefront-api/reference/mutation/checkoutcreate
 *
 * @param {{multipassToken: String}} multipassToken
 */
const customerAccessTokenCreateWithMultipass = (client, variables) => client.mutate({ mutation, variables })

export default customerAccessTokenCreateWithMultipass
